import React, { CSSProperties } from 'react';

import styles from './section-icon.module.scss';


interface ISectionIconProps {
  style?: CSSProperties;
}

export default function SectionIcon({ style }: ISectionIconProps) {
  return (
    <div
      style={style}
      className={styles['ag-section-icon']}
    >
      <span />
      <span />
      <span />
      <span />
    </div>
  );
}
